import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { useAuth } from "@/contexts/AuthContext";

export function useIsSeller() {
  const { user } = useAuth();

  const { data, isLoading } = useQuery({
    queryKey: ["profiles", "account_type", user?.id],
    queryFn: async () => {
      if (!user?.id) return null;
      const { data, error } = await supabase
        .from("profiles")
        .select("account_type")
        .eq("id", user.id)
        .maybeSingle();
      if (error) throw error;
      return data;
    },
    enabled: !!user?.id,
    staleTime: 60_000,
  });

  const isSeller = (data?.account_type ?? null) === "seller";
  return { isSeller, loading: isLoading };
}
